// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-img.logo::part(image) {
  margin: auto;
  padding: 15px;
  width: -webkit-fill-available;
  max-width: 150px;
  border-radius: 15px;
}

.selected {
  --background: white !important;
  --color: var(--ion-color-secondary) !important;
  --color-hover: var(--ion-color-secondary) !important;
  font-weight: bold;
}

ion-button.selected::part(native) {
  box-shadow: none !important;
}

ion-split-pane {
  --side-width: 250px;
  --side-max-width: 250px;
  --side-min-width: 250px;
}
ion-split-pane ion-header {
  box-shadow: none;
}
ion-split-pane ion-header ion-toolbar {
  display: flex;
  min-height: 100px;
  max-height: 100px;
}
ion-split-pane ion-header ion-toolbar div.toolbar-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-split-pane ion-content {
  --background: var(--ion-color-primary);
}
ion-split-pane ion-content ion-label.header {
  font-weight: bold;
  white-space: break-spaces;
}
ion-split-pane ion-content ion-list {
  background: var(--ion-color-primary);
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 2px;
  padding-right: 2px;
}
ion-split-pane ion-content ion-list ion-item {
  --background: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary);
  --color: white;
  --color-hover: white;
  margin-bottom: 3px;
  font-size: 20px !important;
}
ion-split-pane ion-content ion-list ion-item ion-label {
  font-size: 20px !important;
}
ion-split-pane ion-item::part(native) {
  min-height: 70px;
}
ion-split-pane ion-menu {
  border-right: 0px;
  transition: all 0.2s ease-in;
}
ion-split-pane ion-menu::part(container) {
  box-shadow: 4px 0px 16px var(--ion-color-primary);
}
ion-split-pane ion-footer {
  background: var(--ion-color-primary);
  box-shadow: none;
}
ion-split-pane ion-footer ion-button {
  min-height: 70px;
}
ion-split-pane ion-footer ion-item {
  min-height: 70px;
  cursor: pointer;
  --background: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary);
  --color: white;
  --color-hover: white;
  margin-bottom: 3px;
  font-size: 20px !important;
}
ion-split-pane ion-footer ion-item ion-label {
  font-size: 20px !important;
}

ion-split-pane.reduced-side-pane {
  --side-width: 100px;
  --side-max-width: 100px;
  --side-min-width: 100px;
}

.reduced {
  min-height: 70px;
  text-transform: none;
  font-size: 18px !important;
}
.reduced span {
  display: grid;
}
.reduced ion-label {
  font-size: 14px !important;
  white-space: normal;
}

.reduced:has(ion-label) fa-icon {
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EAGA,mBAAA;AAHJ;;AAMA;EACI,8BAAA;EACA,8CAAA;EACA,oDAAA;EACA,iBAAA;AAHJ;;AAQA;EAEI,2BAAA;AANJ;;AASA;EACI,mBAAA;EACA,uBAAA;EACA,uBAAA;AANJ;AAQI;EACI,gBAAA;AANR;AAQQ;EACI,aAAA;EAEA,iBAAA;EACA,iBAAA;AAPZ;AASY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAPhB;AAYI;EACI,sCAAA;AAVR;AAYQ;EACI,iBAAA;EACA,yBAAA;AAVZ;AAaQ;EACI,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAXZ;AAaY;EACI,sCAAA;EAGA,4CAAA;EAEA,cAAA;EAGA,oBAAA;EACA,kBAAA;EACA,0BAAA;AAhBhB;AAkBgB;EACI,0BAAA;AAhBpB;AAuBI;EAEI,gBAAA;AAtBR;AAyBI;EACI,iBAAA;EACA,4BAAA;AAvBR;AA0BI;EAEI,iDAAA;AAzBR;AA4BI;EACI,oCAAA;EACA,gBAAA;AA1BR;AA4BQ;EACI,gBAAA;AA1BZ;AA6BQ;EACI,gBAAA;EACA,eAAA;EACA,sCAAA;EAGA,4CAAA;EAEA,cAAA;EAGA,oBAAA;EACA,kBAAA;EACA,0BAAA;AAhCZ;AAkCY;EACI,0BAAA;AAhChB;;AAsCA;EACI,mBAAA;EACA,uBAAA;EACA,uBAAA;AAnCJ;;AAuCA;EACI,gBAAA;EACA,oBAAA;EACA,0BAAA;AApCJ;AAsCI;EACI,aAAA;AApCR;AAuCI;EACI,0BAAA;EACA,mBAAA;AArCR;;AA2CI;EACI,kBAAA;AAxCR","sourcesContent":["ion-img.logo {}\n\nion-img.logo::part(image) {\n    margin: auto;\n    padding: 15px;\n    width: -webkit-fill-available;\n    max-width: 150px;\n    // max-height: 100%;\n\n    border-radius: 15px;\n}\n\n.selected {\n    --background: white !important;\n    --color: var(--ion-color-secondary) !important;\n    --color-hover: var(--ion-color-secondary) !important;\n    font-weight: bold;\n\n\n}\n\nion-button.selected::part(native){\n\n    box-shadow: none !important;\n}\n\nion-split-pane {\n    --side-width: 250px;\n    --side-max-width: 250px;\n    --side-min-width: 250px;\n\n    ion-header {\n        box-shadow: none;\n\n        ion-toolbar {\n            display: flex;\n\n            min-height: 100px;\n            max-height: 100px;\n\n            div.toolbar-content {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n        }\n    }\n\n    ion-content {\n        --background: var(--ion-color-primary);\n\n        ion-label.header {\n            font-weight: bold;\n            white-space: break-spaces;\n        }\n\n        ion-list {\n            background: var(--ion-color-primary);\n            padding-top: 4px;\n            padding-bottom: 4px;\n            padding-left: 2px;\n            padding-right: 2px;\n\n            ion-item {\n                --background: var(--ion-color-primary);\n                // --background-activated: var(--ion-color-primary);\n                // --background-focused: var(--ion-color-primary);\n                --background-hover: var(--ion-color-primary);\n                // --border-radius: 20px;\n                --color: white;\n                // --color-activated: white;\n                // --color-focused: white;\n                --color-hover: white;\n                margin-bottom: 3px;\n                font-size: 20px !important;\n\n                ion-label {\n                    font-size: 20px !important;\n                }\n            }\n\n        }\n    }\n\n    ion-item::part(native) {\n\n        min-height: 70px;\n    }\n\n    ion-menu {\n        border-right: 0px;\n        transition: all 0.2s ease-in;\n    }\n\n    ion-menu::part(container) {\n\n        box-shadow: 4px 0px 16px var(--ion-color-primary);\n    }\n\n    ion-footer {\n        background: var(--ion-color-primary);\n        box-shadow: none;\n\n        ion-button {\n            min-height: 70px;\n        }\n\n        ion-item {\n            min-height: 70px;\n            cursor: pointer;\n            --background: var(--ion-color-primary);\n            // --background-activated: var(--ion-color-primary);\n            // --background-focused: var(--ion-color-primary);\n            --background-hover: var(--ion-color-primary);\n            // --border-radius: 20px;\n            --color: white;\n            // --color-activated: white;\n            // --color-focused: white;\n            --color-hover: white;\n            margin-bottom: 3px;\n            font-size: 20px !important;\n\n            ion-label {\n                font-size: 20px !important;\n            }\n        }\n    }\n}\n\nion-split-pane.reduced-side-pane {\n    --side-width: 100px;\n    --side-max-width: 100px;\n    --side-min-width: 100px;\n\n}\n\n.reduced {\n    min-height: 70px;\n    text-transform: none;\n    font-size: 18px !important;\n\n    span {\n        display: grid;\n    }\n\n    ion-label {\n        font-size: 14px !important;\n        white-space: normal;\n    }\n}\n\n.reduced:has(ion-label) {\n\n    fa-icon {\n        margin-bottom: 5px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
